/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%]{background-color:#e6e6e6;bottom:0}.footer-logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
